import {doPost, doGet} from './Base';


const getShortLinkolns = async (domain) => {
  if (!domain) {
      return [];
  }
  const url = '/short_linkolns/' + domain;
  return await doGet(url, {});
};

const saveShortLinkoln = async (domain, short_linkoln) => {
  const url = '/short_linkoln/' + domain;
  return await doPost(url, short_linkoln);
}


export {getShortLinkolns, saveShortLinkoln};
export default getShortLinkolns;
